import { Preferences } from "@capacitor/preferences";
import type { AddLocalNotificationInput } from "./NotificationsContext";
import { createUserNotification } from "../api/notifications";

function todayParts() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const year = String(now.getFullYear());
  return { year, month, day };
}

function monthDayFromDateStr(dateStr?: string | null) {
  if (!dateStr) return null;
  const clean = dateStr.slice(0, 10);
  const [ , month, day ] = clean.split("-");
  if (!month || !day) return null;
  return `${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

function lastNotifiedKey(userId: number) {
  return `birthday_notified_${userId}`;
}

function buildNotificationBody(fullName?: string | null) {
  const firstName = fullName?.trim().split(/\s+/)[0];
  return firstName
    ? `¡Feliz cumpleaños, ${firstName}! Disfruta tu día.`
    : "¡Feliz cumpleaños! Disfruta tu día.";
}

export async function sendBirthdayGreetingOnce(params: {
  userId: number;
  dateOfBirth?: string | null;
  fullName?: string | null;
  addLocalNotification: (input: AddLocalNotificationInput) => void;
}) {
  const { userId, dateOfBirth, fullName, addLocalNotification } = params;
  if (!userId || !dateOfBirth || !addLocalNotification) return false;

  const dobMonthDay = monthDayFromDateStr(dateOfBirth);
  if (!dobMonthDay) return false;

  const { year, month, day } = todayParts();
  const todayMonthDay = `${month}-${day}`;
  if (dobMonthDay !== todayMonthDay) return false;

  try {
    const key = lastNotifiedKey(userId);
    const { value: lastNotified } = await Preferences.get({ key });
    const todayYmd = `${year}-${month}-${day}`;
    if (lastNotified === todayYmd) return false;

    const id = `birthday-${userId}-${todayYmd}`;
    const nowIso = new Date().toISOString();
    const title = "¡Feliz cumpleaños!";
    const description = buildNotificationBody(fullName);

    let createdAt = nowIso;
    let remoteId = id;

    try {
      const created = await createUserNotification(userId, {
        title,
        message: description
      });
      if (created?.created_at) createdAt = created.created_at;
      if (created?.notification_id) remoteId = String(created.notification_id);
    } catch (apiErr) {
      console.warn("No se pudo guardar la notificación de cumpleaños en servidor:", apiErr);
    }

    addLocalNotification({
      id: remoteId,
      title,
      description,
      date: createdAt,
      read: false,
    });

    await Preferences.set({ key, value: todayYmd });
    return true;
  } catch (err) {
    console.warn("No se pudo programar la notificación de cumpleaños:", err);
    return false;
  }
}
